import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import Spinner from 'react-bootstrap/Spinner';
import { toast } from 'react-toastify';
import 'react-datepicker/dist/react-datepicker.css';
import { Table, Pagination, Checkbox } from 'antd';




import 'react-datepicker/dist/react-datepicker.css';
import { useForm, Controller, Feedback } from 'react-hook-form';
import axios from 'axios';
import { FaCalendarAlt } from 'react-icons/fa';

import { NavLink, useLocation } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import TableComponent from '../../components/Desenganche/Filtrado';
import FormularComponen from '../../components/Desenganche/Formulario';
import { URL_EMPLOYEE } from '../../constans/servidor';
import { set } from 'immutable';


const columns = [
  {
    title: 'Parqueadero',
    dataIndex: 'nombre_park',
  },
  {
    title: 'Placa',
    dataIndex: 'placa',
  },
  {
    title: 'Estado',
    dataIndex: 'estado',
    render: estado => (
      <span className={estado == 'procesado' ? "texto-tabla" : "texto-tabla2"}>{estado}</span>
    )
  },
  {
    title: 'Fecha',
    dataIndex: 'fechaSolicitud',
  }
];


const SolicitudesComponen = props => {
  const [loading, setLoading] = useState(true);
  const [fechaSeleccionada, setFechaSeleccionada] = useState(null);
  const [data, setData] = useState();
  const [estados, setEstado] = useState(false)
  const {
    control,
    watch,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const onSubmit = async (data) => {
    setLoading(true)
    // creas un array vacío
    console.log(data.solicitud);
    var fechaSeleccionada = new Date(data.solicitud);
    var anio = fechaSeleccionada.getFullYear();
    var mes = fechaSeleccionada.getMonth() + 1;
    var dia = fechaSeleccionada.getDate();
    var fechaFormateada = anio + "-" + (mes < 10 ? "0" + mes : mes) + "-" + (dia < 10 ? "0" + dia : dia);
    console.log(fechaFormateada);
    try {

      const resultado = await axios.get(`${URL_EMPLOYEE}/desenganchadas/getfechaSolicitud/${fechaFormateada}`)
      console.log(resultado);
      if (resultado.data["status"]) {
        setLoading(false)
        setEstado(true)
        let objeto = resultado.data["data"]
        for (let i = 0; i < objeto.length; i++) {
          const fecha_hora_sin_z = objeto[i].fechaSolicitud.slice(0, -1);
          const fecha = new Date(fecha_hora_sin_z);
          const fechaFormateada = fecha.toLocaleDateString('es-CO', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/\//g, '/') + ' ' + fecha.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

          console.log(fechaFormateada, "Fecha Solicitud");
          // objeto[i].fecha_hora = fechaFormateada;
          objeto[i].fechaSolicitud = fechaFormateada;
          if (objeto[i].estado == '1') {
            objeto[i].estado = 'procesado'
          }
          if (objeto[i].estado == '0') {
            objeto[i].estado = 'solicitado'
          }

        }
        setData(objeto)
        toast.success(resultado.data["message"])

      } else {
        setLoading(false)
        setEstado(false)
        setData('')
        toast.error(resultado.data["message"])
      }
    } catch (error) {
      toast.error('Algo salio mal..');
    }

  }
  useEffect(() => {
    setTimeout(() => {
      setLoading(false)
    }, 800);

  }, []);
  return loading ? (
    <div className="cargando">
      <div className="loader" id="loader">
        Loading...
      </div>
    </div>
  ) : (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row className="contenedorT-Filtrado">
          <Col xs={12} sm={4} md={4} lg={4} xl={4}>
            <Form.Group controlId="formBasicEmail">
              <Form.Label className='texto-label'>Fecha de Solicitud</Form.Label>
              <Controller
                name="solicitud"
                control={control}
                rules={{ required: true }}
                defaultValue={new Date()}
                render={({ field: { onChange, onBlur, value } }) => (
                  <DatePicker
                    className="form-control"
                    selected={value}
                    dateFormat="yyyy-MM-dd"
                    onChange={(date) => onChange(date)}
                  />
                )}
              />
            </Form.Group>
          </Col>

        </Row>
        <Row className="justify-content-end mbottom-20">
          <Button type="submit" variant="primary" className=" btn btn-primary mtop-20 boton"
          >
            Consultar Solicitudes
          </Button>
        </Row>
      </form>
      {estados ? (

        <Table
          columns={columns}
          dataSource={data}
          pagination={{
            defaultPageSize: 50,
            className: "pagination"
          }}
        />
      ) : null}
    </>

  );

};
export default SolicitudesComponen;